// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u7-2";
export var chatLink = "_u7-0";
export var chatText = "_u7-1";